/**
 * Staging Banner
 *
 * A slim amber marker on the top edge so a staging session can never be
 * mistaken for production. Renders nothing unless the bundle was built by
 * scripts/staging/build-staging.js (REACT_APP_ENV=staging), so the production
 * DOM is unchanged. Fixed-position and pointer-events: none, so it neither
 * shifts layout nor blocks clicks on what sits underneath.
 */

import React from 'react';
import { IS_STAGING, PROJECT_ID } from '../../config/env';

const AMBER = '#fbbf24';

const barStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    background: AMBER,
    zIndex: 2147483000,
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
};

const labelStyle = {
    marginTop: 3,
    padding: '1px 8px',
    background: AMBER,
    color: '#1c1917',
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
    borderRadius: '0 0 4px 4px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
};

const StagingBanner = () => {
    if (!IS_STAGING) {
        return null;
    }

    return (
        <div style={barStyle} data-app-env="staging">
            <span style={labelStyle}>{`STAGING — ${PROJECT_ID}`}</span>
        </div>
    );
};

export default StagingBanner;
